import styles from './category-card.module.scss';
import React from "react";
import { Link } from "react-router-dom";

import { CategoryCard as CategoryCardData } from "../../data/site";

export interface CategoryCardProps {
  name?: string;
  classes?: string;
  category: CategoryCardData;
  /** URL asignada: si viene, la tarjeta navega (react-router `Link`). */
  to?: string;
}

/**
 * Tarjeta de categoría de "Nuestros productos" (Figma Inicio 186:36/211/212).
 * Contenedor azul marino redondeado con título (Montserrat 600), imagen
 * cuadrada y descripción (Open Sans). Si recibe `to`, es un enlace navegable.
 */
export default class CategoryCard extends React.Component<CategoryCardProps> {
  static jsClass = "CategoryCard";
  static defaultProps: Partial<CategoryCardProps> = {
    name: "mbCategoryCard",
  };

  render(): React.ReactNode {
    const { classes, category, to } = this.props;
    if (!category) return null;

    const className = styles['mb-category-card'] + (classes ? ' ' + classes : '');
    const inner = (
      <>
        <h3 className={styles['mb-category-card__title']}>{category.title}</h3>
        <img
          className={styles['mb-category-card__img']}
          src={category.image}
          alt={category.title}
          loading="lazy"
        />
        <p className={styles['mb-category-card__copy']}>{category.copy}</p>
      </>
    );

    return to ? (
      <Link className={className + ' ' + styles['mb-category-card--link']} to={to}>
        {inner}
      </Link>
    ) : (
      <article className={className}>{inner}</article>
    );
  }
}
